import { Link } from "react-router-dom";
import { artAssets } from "../data/site";
import { Reveal } from "./Reveal";

export function RecruitmentBanner() {
  return (
    <section className="recruitment-banner" data-testid="recruitment-banner-section">
      <Reveal className="recruitment-banner-frame">
        <Link
          to="/enlist"
          className="recruitment-banner-link"
          aria-label="Open the Apex-Courier enlistment form"
          data-testid="recruitment-enlist-link"
        >
          <img loading="lazy"
            src={artAssets.recruitmentBanner}
            alt="Official recruitment banner for the Apex-Courier MK-VII elite fleet"
            data-testid="recruitment-banner-image"
          />
        </Link>
      </Reveal>
    </section>
  );
}
